
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-relationship-style.html
riot.tag2('menu-item-relationship-style',
  '<svg class="floating-menu_icon line-preview"> <path d="M 0 8 L 40 8" stroke-dasharray="{this.getLinePreviewStyle()}" stroke-width="{this.getLinePreviewWidth()}" stroke="{this.getLinePreviewColor()}"> </svg> <span class="floating-menu_label">Line Style</span> <svg class="floating-menu_caret"> <use xlink:href="#caret-right-icon"></use> </svg> <div class="colorPicker"> <color-picker if="{isOpen}" positioning="{colorPickerPosition()}" colors="{relationshipColors}" setcolor="{setRelationshipColor}" setlinetype="{setLineType}" setlinewidth="{setLineWidth}" subject="relationship" type="bulk"></color-picker> </div>',
  '',
  'class="{opts.classes} floating-menu_item" onmouseenter="{openRelationshipStylePicker}"', function(opts) {
'use strict';

var _this = this;

var _constants = require('lib/constants');

var _menuUi = require('lib/menu-ui');

var _delayHandler = require('lib/delay-handler');

this.isOpen = false;
this.relationshipColors = _constants.LINK_COLORS;

this.setRelationshipColor = _menuUi.mui.setRelationshipColor.bind(this);
this.setLineType = _menuUi.mui.setLineType.bind(this);
this.setLineWidth = _menuUi.mui.setLineWidth.bind(this);
this.getBulkColor = _menuUi.mui.getBulkColor.bind(this);
this.getBulkLineType = _menuUi.mui.getBulkLineType.bind(this);
this.getBulkLineWidth = _menuUi.mui.getBulkLineWidth.bind(this);
this.getLinePreviewColor = _menuUi.mui.getLinePreviewColor.bind(this);
this.getLinePreviewStyle = _menuUi.mui.getLinePreviewStyle.bind(this);
this.getLinePreviewWidth = _menuUi.mui.getLinePreviewWidth.bind(this);

_menuUi.mui.registerMenuItem(this, 'relationshipStyle');

this.openRelationshipStylePicker = function () {
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'linkcolor',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      _this.noHide = true; // don't trigger hideSubMenu in this component when parent.hideSubmenus is called
      _this.parent.hideSubMenus();
      _this.isOpen = true;
      _this.update();
    }
  });
};

this.hideSubMenu = function () {
  if (_this.isOpen && !_this.noHide) {
    _this.isOpen = false;
    _this.update();
  }
  delete _this.noHide;
};

this.colorPickerPosition = function (type) {
  if (_this.parent.positionSubToLeft) {
    return 'top: 0px; left: -253px;';
  }
  return 'top: 0px; left: 100%';
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-relationship-style')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-relationship-style.html
// module id = 695
// module chunks = 0